import Immutable from 'immutable';
import { FLAG_GETTING_MANUAL_VOUCHER_SERVICE_TYPES,
GET_MANUAL_VOUCHER_SERVICE_TYPES,
CLEAR_MANUAL_VOUCHER_SERVICE_TYPES } from '../../../actions/types/accounting';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_MANUAL_VOUCHER_SERVICE_TYPES:
      return state.setIn(['all', 'loading'], payload);
    case GET_MANUAL_VOUCHER_SERVICE_TYPES:
      return state.setIn(['all', 'content'], Immutable.List(payload));
    case CLEAR_MANUAL_VOUCHER_SERVICE_TYPES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};